import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e37f0f16"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "d-flex flex-wrap justify-content-center valores-sugeridos" };
const _hoisted_2 = { class: "form-group has-float-label" };
const _hoisted_3 = ["onUpdate:modelValue", "onBlur"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_input_format = _resolveDirective("input-format");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.valores, (vl, ix) => {
            return (_openBlock(), _createElementBlock("div", {
                key: ix,
                class: "valor-sugerido"
            }, [
                _createElementVNode("label", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        require: "",
                        onClick: _cache[0] || (_cache[0] = ($event) => { _ctx.onClick($event); }),
                        class: "form-control",
                        "onUpdate:modelValue": ($event) => ((_ctx.valores[ix]) = $event),
                        placeholder: " ",
                        onBlur: ($event) => (_ctx.onBlur(ix))
                    }, null, 40, _hoisted_3), [
                        [_vModelText, _ctx.valores[ix]],
                        [_directive_input_format, 'moeda-inteiro']
                    ]),
                    _createElementVNode("span", null, " Opção " + _toDisplayString(ix + 1), 1)
                ])
            ]));
        }), 128))
    ]));
}
